module.exports = __webpack_public_path__ + "img/fullscreen_exit-white-18dp.923816cd.svg";